import React, { useState } from 'react';
import {
	makeStyles,
	Button,
	MenuItem,
	LinearProgress,
	Box,
	TextField,
	InputAdornment,
	Grid,
	Tabs,
	Tab,
	Divider,
	withStyles,
	FormControlLabel,
	Checkbox,
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';

// import { TextField } from 'formik-material-ui';
// import TextField from '@material-ui/core/TextField
import { Field, Form, Formik } from 'formik';
import PhoneIcon from '@material-ui/icons/Phone';
import TitleText from '../../components/reusableComponents/TitleText';
import { useMediaQuery, useTheme } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import BodyText from './BodyText';
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
import LocationOnIcon from '@material-ui/icons/LocationOn';
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
		},
		backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 10,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
	},
	InputPropsStyle: {
		backgroundColor: 'white',
		borderRadius: 25,
	},
	inputPropsStyle: {
		padding: 14,
	},
	createButton: {
		backgroundColor: '#39c9bb',
		color: 'white',
		borderRadius: 25,
		width: '100%',
		padding: '11px 8px',
		'&:hover': {
			backgroundColor: '#39c9bb',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
}));
const GreenCheckbox = withStyles({
	root: {
		color: '#39c9bb',
		'&$checked': {
			color: '#39c9bb',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const country = ['Jharkhand', 'Kolkata'];
const SummaryForm = () => {
	const classes = useStyles();
	// const theme = useTheme();
	const [tabvalue, setValue] = React.useState(0);
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	const [check, setCheck] = useState(false);
	const handleCheck = (event) => {
		setCheck(event.target.checked);
	};
	const [currentStep, SetCurrentStep] = useState('Step 1');

	// const matches = useMediaQuery(theme.breakpoints.down('xs'));
	const handleSubmit = (data) => {
		console.log(data);
	};

	return (
		<>
			<Formik
				initialValues={{}}
				validate={(values) => {
					const errors = {};
				}}
				onSubmit={handleSubmit}>
				{({ submitForm, isSubmitting }) => (
					<>
						<Form>
							<>
								<Grid container spacing={2} alignItems='center'>
									<Grid item xs={5}>
										<Field
											component={TextField}
											name='first_name'
											type='text'
											variant='outlined'
											label='Enter Email ID'
											style={{ marginTop: 20 }}
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
												startAdornment: (
													<InputAdornment position='start'>
														<EmailIcon />
													</InputAdornment>
												),
											}}
											inputProps={{
												style: { padding: 14 },
											}}
										/>
									</Grid>
									<Grid item xs={3}>
										<Field
											component={TextField}
											name='first_name'
											type='select'
											variant='outlined'
											label='Enter Mobile No.'
											style={{ marginTop: 20 }}
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
												startAdornment: (
													<InputAdornment position='start'>
														<PhoneIcon />
													</InputAdornment>
												),
											}}
											inputProps={{
												style: { padding: 14 },
											}}
										/>
									</Grid>
									<Grid item xs={3}>
										<Field
											component={TextField}
											select
											name='user'
											type='text'
											variant='outlined'
											label='Select State'
											style={{ marginTop: 19 }}
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
												startAdornment: (
													<InputAdornment position='start'>
														<LocationOnIcon />
													</InputAdornment>
												),
											}}
											inputProps={{
												className: classes.inputPropsStyle,
											}}>
											{country.map((item, index) => (
												<MenuItem key={index} value={item}>
													{item}
												</MenuItem>
											))}
										</Field>
									</Grid>
								</Grid>
							</>
						</Form>
					</>
				)}
			</Formik>
		</>
	);
};

export default SummaryForm;
